import { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { useForm } from "react-hook-form";
import moment from "moment";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import SuccessModal from "../../components/SuccessModal";

const Index = () => {
  const { register, handleSubmit, getValues, setValue } = useForm();
  const { register: registerNewsletter, handleSubmit: handleSubmitNewsletter, formState: { errors: ErrorsNewsletter }, reset } = useForm();

  const [defaultTemplate, setDefaultTemplate] = useState([]);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const Navigate = useNavigate();
  const [showModel, setShowModel] = useState(false);
  const [count, setCount] = useState();
  const [checkedValue, setCheckedValue] = useState(false);
  const [pageData, setPageData] = useState({ page: 1, perPage: 5000 });
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllDefaultTemplate(); }, [pageData]);

  const getAllDefaultTemplate = () => {
    get(`/default-template?page=${pageData?.page || 1}&perPage=${pageData?.perPage || 10}&searchItem=${getValues("companyName") || ""}`)
      .then((res) => { setDefaultTemplate(res?.data); setCount(res?.pages); })
      .catch((err) => console.log(err));
  };

  const onSubmit = () => getAllDefaultTemplate();
  const clearSearch = () => { setValue("companyName", ""); getAllDefaultTemplate(); };

  const onSubmitNewsletter = (data) => {
    if (checkBoxData.length > 0) {
      post(`${baseURL}/news-letter/reply`, { email: checkBoxData, message: data.message, subject: data.subject })
        .then((res) => {
          if (res?.status) { setModalData({ message: res.message, show: true }); setValue("message", ""); setCheckBoxData([]); reset(); setShowModel(false); }
          else toast.error(res?.message);
        }).catch((err) => toast.error(err?.response?.data?.error));
    }
  };

  const changeStatus = (id, status) => {
    post(`${baseURL}/default-template/status`, { id, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllDefaultTemplate(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (id) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the template.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/default-template/delete`, { id })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllDefaultTemplate(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const checkBoxHandler = (email) => {
    setCheckBoxData(prev => prev.includes(email) ? prev.filter(i => i !== email) : [...prev, email]);
  };

  const allCheck = (val) => {
    setCheckBoxData(val ? defaultTemplate.map(item => item.email) : []);
    setCheckedValue(!checkedValue);
  };

  useEffect(() => {
    if (defaultTemplate.length > 0) {
      setCheckedValue(defaultTemplate.length === checkBoxData.length);
    }
  }, [checkBoxData]);

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const reorderedItems = Array.from(defaultTemplate);
    const [movedItem] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, movedItem);
    setDefaultTemplate(reorderedItems);
    post(`/default-template/update-sequence`, { items: reorderedItems })
      .then((res) => { if (res?.status) getAllDefaultTemplate(); else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );
  const thS = (align = 'left') => ({ padding: '12px 16px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: align, borderBottom: '1px solid #edf0f7', background: '#f8f9fc', whiteSpace: 'nowrap' });
  const tdS = (align = 'left') => ({ padding: '12px 16px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle', textAlign: align });
  const inputS = { width: '100%', padding: '10px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 14, color: '#0a1628', background: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Default Templates</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Manage templates and custom fields</p>
          </div>
          <Link to="/admin/default-template/add" style={{ textDecoration: 'none' }}>
            <button style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Add Template</button>
          </Link>
        </div>

        {/* Search */}
        <div style={{ padding: '12px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <input placeholder="Search templates..." {...register("companyName")} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, color: '#0a1628', outline: 'none', width: 240, fontFamily: 'inherit' }} />
          <button onClick={onSubmit} style={{ background: '#1a2744', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Search</button>
          <button onClick={clearSearch} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Clear</button>
        </div>

        {/* Drag hint */}
        <div style={{ padding: '8px 24px', background: '#fffbeb', borderBottom: '1px solid #fef3c7', fontSize: 12, color: '#92400e', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>⇅</span> Drag rows to reorder templates
        </div>

        {/* Table with DnD */}
        <div style={{ overflowX: 'auto' }}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-table">
              {(provided) => (
                <table style={{ width: '100%', borderCollapse: 'collapse' }} ref={provided.innerRef} {...provided.droppableProps}>
                  <thead>
                    <tr>
                      <th style={{ ...thS('center'), width: 50 }}>⇅</th>
                      <th style={{ ...thS('left'), minWidth: 200 }}>Name</th>
                      <th style={{ ...thS('left'), minWidth: 200 }}>Create Date</th>
                      <th style={{ ...thS('center'), width: 120 }}>Status</th>
                      <th style={{ ...thS('center'), width: 140 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {defaultTemplate?.length > 0 ? defaultTemplate.map((item, index) => (
                      <Draggable key={item._id} draggableId={item._id} index={index}>
                        {(provided) => (
                          <tr ref={provided.innerRef} {...provided.draggableProps}
                            onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                            <td style={{ ...tdS('center'), width: 50, cursor: 'grab' }} {...provided.dragHandleProps}>
                              <span style={{ color: '#c0c8d8', fontSize: 16 }}>⠿</span>
                            </td>
                            <td style={{ ...tdS('left'), minWidth: 200 }}>
                              <Link to={`/admin/template/manage-field?${item._id}`} style={{ color: '#1d4ed8', fontWeight: 600, textDecoration: 'none' }}>
                                {item?.templateName}
                              </Link>
                            </td>
                            <td style={{ ...tdS('left'), color: '#6b7a99', fontSize: 13, minWidth: 200 }}>{moment(item?.createdAt).format("MMMM DD, YYYY hh:mm A")}</td>
                            <td style={{ ...tdS('center'), width: 120 }}>{pill(item?.isActive)}</td>
                            <td style={{ ...tdS('center'), width: 140 }}>
                              <div style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                                <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {item?.isActive ? '✕' : '✓'}
                                </button>
                                <button onClick={() => Navigate(`/admin/default-template/edit?${item._id}`)} title="Edit"
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>✎</button>
                                <button onClick={() => deleteHandler(item._id)} title="Delete"
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>🗑</button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    )) : (
                      <tr><td colSpan={5} style={{ ...tdS('center'), padding: '48px', color: '#9aa5c0' }}>No templates found</td></tr>
                    )}
                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>

      {/* Newsletter Reply Modal (kept from original) */}
      {showModel && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, width: 520, boxShadow: '0 20px 60px rgba(0,0,0,.2)', overflow: 'hidden' }}>
            <div style={{ padding: '18px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#0a1628' }}>Message Reply</h3>
              <button onClick={() => { setShowModel(false); }} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#9aa5c0' }}>×</button>
            </div>
            <form onSubmit={handleSubmitNewsletter(onSubmitNewsletter)} style={{ padding: '24px' }}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Subject</label>
                <input placeholder="Enter subject" type="text" style={inputS} {...registerNewsletter("subject", { required: true })} />
                {ErrorsNewsletter.subject && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Message</label>
                <textarea placeholder="Enter message" rows={4} style={{ ...inputS, resize: 'vertical' }} {...registerNewsletter("message", { required: true })} />
                {ErrorsNewsletter.message && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setShowModel(false)} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Close</button>
                <button type="submit" style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
